import React from 'react';

export interface CustomIconProps {
  filled?: boolean;
  width?: string;
}

const ShareIcon: React.FC<CustomIconProps> = ({ width }) => {
  return (
    <svg
      width={width ?? '24'}
      height={width ?? '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M11.4697 2.46967C11.7626 2.17678 12.2374 2.17678 12.5303 2.46967L16.0303 5.96967C16.3232 6.26256 16.3232 6.73744 16.0303 7.03033C15.7374 7.32322 15.2626 7.32322 14.9697 7.03033L12.75 4.81066V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V4.81066L9.03033 7.03033C8.73744 7.32322 8.26256 7.32322 7.96967 7.03033C7.67678 6.73744 7.67678 6.26256 7.96967 5.96967L11.4697 2.46967ZM4.75 13C4.75 12.5858 4.41421 12.25 4 12.25C3.58579 12.25 3.25 12.5858 3.25 13V19C3.25 20.5188 4.48122 21.75 6 21.75H18C19.5188 21.75 20.75 20.5188 20.75 19V13C20.75 12.5858 20.4142 12.25 20 12.25C19.5858 12.25 19.25 12.5858 19.25 13V19C19.25 19.6904 18.6904 20.25 18 20.25H6C5.30964 20.25 4.75 19.6904 4.75 19V13Z'
        fill='white'
      />
    </svg>
  );
};

export default ShareIcon;
